import React, {
  useEffect,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";

import {
  DragDropContext,
  Droppable,
  Draggable,
} from "@hello-pangea/dnd";

const Captcha = forwardRef(({ onSolvedChange }, ref) => {

  const [numbers, setNumbers] = useState([]);
  const [isAscending, setIsAscending] = useState(false);

  useEffect(() => {
    generateCaptcha();
  }, []);

  useEffect(() => {
    if (onSolvedChange) {
      onSolvedChange(isAscending);
    }
  }, [isAscending, onSolvedChange]);

  const isAscendingOrder = (arr) => {

    for (let i = 1; i < arr.length; i++) {
      if (arr[i] < arr[i - 1]) {
        return false;
      }
    }

    return true;
  };

  /* RANDOM NUMBER */
  const getSecureRandom = () => {

    const array = new Uint32Array(1);

    crypto.getRandomValues(array);

    return array[0] % 100;
  };

  /* GENERATE CAPTCHA */
  const generateCaptcha = () => {

    let randomNumbers;

    do {

      randomNumbers = Array.from(
        { length: 3 },
        () => getSecureRandom()
      );

    } while (isAscendingOrder(randomNumbers));

    setNumbers(randomNumbers);
    setIsAscending(false);
  };

  /* RESET */
  useImperativeHandle(ref, () => ({
    resetCaptcha: () => {
      generateCaptcha();
    },
  }));

  /* DRAG END */
  const handleDragEnd = (result) => {

    if (!result.destination) return;

    const items = [...numbers];

    const [removed] = items.splice(result.source.index, 1);

    items.splice(result.destination.index, 0, removed);

    setNumbers(items);

    const sorted = [...items].sort((a, b) => a - b);

    setIsAscending(
      JSON.stringify(items) === JSON.stringify(sorted)
    );
  };

  const colors = [
    "#B4B4B8",
    "#E3E1D9",
    "#C7C8CC",
  ];

  return (

    <div className="captcha-main">

      <div className="captcha-header">

        <p>
          Sort numbers in ascending order to submit
        </p>

        <button
          type="button"
          onClick={generateCaptcha}
          className="captcha-refresh"
        >
          Refresh
        </button>

      </div>

      <DragDropContext onDragEnd={handleDragEnd}>

        <Droppable
          droppableId="numbers"
          direction="horizontal"
        >

          {(provided) => (

            <div
              ref={provided.innerRef}
              {...provided.droppableProps}
              className="captcha-box-wrapper"
            >

              {numbers.map((num, index) => (

                <Draggable
                  key={`${num}-${index}`}
                  draggableId={`${num}-${index}`}
                  index={index}
                >

                  {(dragProvided) => (

                    <div
                      ref={dragProvided.innerRef}
                      {...dragProvided.draggableProps}
                      {...dragProvided.dragHandleProps}
                      className="captcha-box"
                      style={{
                        backgroundColor:
                          colors[index % colors.length],
                        ...dragProvided.draggableProps.style,
                      }}
                    >
                      {num}
                    </div>

                  )}

                </Draggable>

              ))}

              {provided.placeholder}

            </div>

          )}

        </Droppable>

      </DragDropContext>

      {isAscending && (
        <p className="captcha-success">
          Captcha verified ✅
        </p>
      )}

    </div>
  );
});

/* DISPLAY NAME */
Captcha.displayName = "Captcha";

export default Captcha;